import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { enforceHttps } from './lib/domain'
import { logger } from './lib/logger'

// Redirige HTTP → HTTPS avant le rendu (sécurité + cohérence des URLs)
enforceHttps()

// Journal système : trace le démarrage de l'application (visible dans
// /superadmin/logs → Logs système quand VITE_PUBLIC_ENABLE_SYSTEM_LOGS=true).
logger.info('application', 'Application démarrée', {
  path: typeof window !== 'undefined' ? window.location.pathname : '/',
  version: typeof __READDY_VERSION_ID__ !== 'undefined' ? __READDY_VERSION_ID__ : null,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
